import { useEffect, useState } from "react";
import { MainPageBase } from "../page-bases/MainPageBase";
import { NoItemContent } from "../page-bases/NoItemContent";
import { Box, Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { SimpleLabel } from "../../components/Label/SimpleLabel";

import LabelButton from "../../components/Button/LabelButton";
import useAppNavigation from "../../hooks/useAppNavigation";
import { distributionDispatchApi } from "../../services/distribution/distribution-dispatch";
import { updatedispatchCart } from "../../store/reducers/distribution/dispatchRecord";
import { formatDate } from "../../utils/common";
import CustomAccordion from "../../components/custom-accordion";
import appRoutePath from "../../config/path";

function DispatchDetailsPage() {
  const [pageState, setPageState] = useState<string>("main");
  const { id } = useParams<{ id: string }>();
  const entryDetail = useAppSelector((data) => data.dispatchCart);

  const dispatch = useAppDispatch();

  const fetchData = async () => {
    const res = await distributionDispatchApi.getDispatchDetail(id ?? "");

    if (res.data) {
      dispatch(updatedispatchCart(res.data));
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useAppNavigation();
  function addNewItem() {}
  function cancelAddItem() {
    // TODO
  }
  function clearSearch() {
    setPageState("empty-db");
  }

  if (!id) {
    return null;
  }
  return (
    <MainPageBase
      pageState={"main"}
      title={`Dispatch Information`}
      cancelBtnClick={() => cancelAddItem()}
      extraComponent={
        <LabelButton
          onPress={() =>
            navigate({ path: appRoutePath.ASSET_DISPATCH_HISTORY_PAGE })
          }
          label={"Back"}
          direction={"left"}
        />
      }
    >
      <Box
        height={`100%`}
        display={"flex"}
        alignItems={pageState !== "main" ? "center" : ""}
        justifyContent={"center"}
      >
        {pageState !== "main" ? (
          <NoItemContent
            type={pageState}
            title={""}
            subtitle={""}
            addItemBtn={() => addNewItem()}
            clearSearchBtn={() => clearSearch()}
          />
        ) : (
          <Stack width={"100%"}>
            <Stack spacing={1.5} marginBottom={2} direction={"column"}>
              <Stack mb={3}>
                <SimpleLabel title="Courier Information" />
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel
                    title="Courier Service Provider"
                    fontWeight={400}
                  />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.courier_service_provider}
                    width={"100%"}
                  />
                </Stack>

                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel
                    title="Courier Transport Mode"
                    fontWeight={400}
                  />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.courier_transport_mode}
                    width={"100%"}
                  />
                </Stack>

                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Vehicle Type" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.vehicle_type}
                    width={"100%"}
                  />
                </Stack>

                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Vehicle Number" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.vehicle_number}
                    width={"100%"}
                  />
                </Stack>

                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Name of Courier" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.name_of_courier}
                    width={"100%"}
                  />
                </Stack>
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Contact of Courier" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.contact_of_courier}
                    width={"100%"}
                  />
                </Stack>
              </Stack>
              <Stack mb={3}>
                <SimpleLabel title="Departure Details" />
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Domain" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.from_location_domain}
                    width={"100%"}
                  />
                </Stack>
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Location" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.from_location}
                    width={"100%"}
                  />
                </Stack>
              </Stack>

              <Stack mb={3}>
                <SimpleLabel title="Distination Details" />
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Domain" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.to_location_domain}
                    width={"100%"}
                  />
                </Stack>
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Location" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={entryDetail.to_location}
                    width={"100%"}
                  />
                </Stack>
              </Stack>

              <Stack direction={"row"} width={"100%"} mt={3}>
                <SimpleLabel title="Dispatch Date" fontWeight={400} />
                <SimpleLabel
                  fontWeight={700}
                  title={formatDate(entryDetail.dispatch_date ?? "")}
                  width={"100%"}
                />
              </Stack>
              <Stack direction={"row"} width={"100%"} mt={3}>
                <SimpleLabel
                  title="Distribution Batch Number"
                  fontWeight={400}
                />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.distribution_batch_number}
                  width={"100%"}
                />
              </Stack>

              <Box mt={5} />
              <CustomAccordion
                title="Package Description"
                info={entryDetail.package_description ?? ""}
              />
              <CustomAccordion
                title="Additional Remarks"
                info={entryDetail.additional_remarks ?? ""}
              />
            </Stack>
          </Stack>
        )}
      </Box>
    </MainPageBase>
  );
}

export { DispatchDetailsPage };
